<template>
  <div class="mian">
    <header>
      <navbar/>
    </header>
    <main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </main>
    <footer>
      <MunFooter/>
    </footer>
    <!-- <rewards></rewards> -->
  </div>
</template>

<script>
import Navbar from "@/components/navbar";
import MunFooter from "@/components/munFooter";
import Rewards from "../components/rewards";

export default {
  name: "index",
  components: {
    Rewards,
    MunFooter,
    Navbar,
  }
}
</script>

<style scoped>
.mian{
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue